// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `bai-catalog-header #root div {
  background-color: #e5e5e5;
  height: 3.7em;
}

bai-catalog-header #root div.col-sm-12 {
  padding-left: 10px;
}

bai-catalog-header #root div.col-sm-1 {
  display: flex;
}

bai-catalog-header #root div.col-sm-4 {
  display: flex;
}

bai-catalog-header #root div.col-sm-4 input[type='text'] {
  border-radius: 0;
  border: 1px solid #a9a9a9;
  background-color: white !important;
  align-self: flex-end;
}

bai-catalog-header #root div.col-sm-4.right-side-links {
  align-items: center;
  justify-content: flex-end;
}

bai-catalog-header button.btn {
  border-radius: 0;
  border: 1px solid transparent;
  border-left: 0;
  align-self: flex-end;
}

bai-catalog-header button.btn:hover,
button.btn:focus {
  border-radius: 0;
  border: 1px solid transparent;
  border-left: 0;
  height: initial;
}

bai-catalog-header #root div.right-nav {
  display: flex;
  align-items: center;
  height: 32px;
  padding: 5px 10px;
}

bai-catalog-header div.right-nav > a {
  font-size: 12px;
  color: #00a1de;
  text-decoration: none;
}

bai-catalog-header div.right-nav > a:hover {
  text-decoration: underline;
}

bai-catalog-header div.right-nav > img {
  margin-right: 5px;
  display: inline;
  width: 32px;
  height: 32px;
}

bai-catalog-header button#catalog-button.btn-div,
bai-catalog-header a#catalog-button.btn-div {
  padding-left: 0;
  padding-right: 0;
  display: flex;
  align-items: center;
  background-color: #1eabe3;
  height: 3.5em;
  margin-top: 0.2em;
  touch-action: manipulation;
  cursor: pointer;
  border: 1px solid transparent;
  color: white;
}

bai-catalog-header a#catalog-button.btn-div {
  font-size: 1.2rem;
  text-decoration: none;
  display: inline-flex;
}

bai-catalog-header button#catalog-button.btn-div > span,
bai-catalog-header a#catalog-button.btn-div > span {
  padding-left: 5px;
  margin-bottom: 0;
  border: 1px solid transparent;
  padding: 0.3em 0.6em;
  font-size: 1.2rem;
}

bai-catalog-header button#catalog-button.btn-div > img,
bai-catalog-header a#catalog-button.btn-div > img {
  width: 32px;
  height: 32px;
  padding-left: 5px;
}

bai-catalog-header button#catalog-button.btn-div:focus,
bai-catalog-header a#catalog-button.btn-div:focus {
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}

bai-catalog-header button#catalog-button.btn-div:active,
bai-catalog-header a#catalog-button.btn-div:active {
  background-image: none;
  outline: 0;
  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  background-color: #d4d4d4;
  border-color: #8c8c8c;
  color: #333;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/baiCatalogHeader.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,oBAAoB;AACtB;;AAEA;;EAEE,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;;EAEE,sBAAsB;EACtB,UAAU;EACV,wDAAwD;EACxD,gDAAgD;EAChD,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,0CAA0C;EAC1C,oBAAoB;AACtB","sourcesContent":["bai-catalog-header #root div {\n  background-color: #e5e5e5;\n  height: 3.7em;\n}\n\nbai-catalog-header #root div.col-sm-12 {\n  padding-left: 10px;\n}\n\nbai-catalog-header #root div.col-sm-1 {\n  display: flex;\n}\n\nbai-catalog-header #root div.col-sm-4 {\n  display: flex;\n}\n\nbai-catalog-header #root div.col-sm-4 input[type='text'] {\n  border-radius: 0;\n  border: 1px solid #a9a9a9;\n  background-color: white !important;\n  align-self: flex-end;\n}\n\nbai-catalog-header #root div.col-sm-4.right-side-links {\n  align-items: center;\n  justify-content: flex-end;\n}\n\nbai-catalog-header button.btn {\n  border-radius: 0;\n  border: 1px solid transparent;\n  border-left: 0;\n  align-self: flex-end;\n}\n\nbai-catalog-header button.btn:hover,\nbutton.btn:focus {\n  border-radius: 0;\n  border: 1px solid transparent;\n  border-left: 0;\n  height: initial;\n}\n\nbai-catalog-header #root div.right-nav {\n  display: flex;\n  align-items: center;\n  height: 32px;\n  padding: 5px 10px;\n}\n\nbai-catalog-header div.right-nav > a {\n  font-size: 12px;\n  color: #00a1de;\n  text-decoration: none;\n}\n\nbai-catalog-header div.right-nav > a:hover {\n  text-decoration: underline;\n}\n\nbai-catalog-header div.right-nav > img {\n  margin-right: 5px;\n  display: inline;\n  width: 32px;\n  height: 32px;\n}\n\nbai-catalog-header button#catalog-button.btn-div,\nbai-catalog-header a#catalog-button.btn-div {\n  padding-left: 0;\n  padding-right: 0;\n  display: flex;\n  align-items: center;\n  background-color: #1eabe3;\n  height: 3.5em;\n  margin-top: 0.2em;\n  touch-action: manipulation;\n  cursor: pointer;\n  border: 1px solid transparent;\n  color: white;\n}\n\nbai-catalog-header a#catalog-button.btn-div {\n  font-size: 1.2rem;\n  text-decoration: none;\n  display: inline-flex;\n}\n\nbai-catalog-header button#catalog-button.btn-div > span,\nbai-catalog-header a#catalog-button.btn-div > span {\n  padding-left: 5px;\n  margin-bottom: 0;\n  border: 1px solid transparent;\n  padding: 0.3em 0.6em;\n  font-size: 1.2rem;\n}\n\nbai-catalog-header button#catalog-button.btn-div > img,\nbai-catalog-header a#catalog-button.btn-div > img {\n  width: 32px;\n  height: 32px;\n  padding-left: 5px;\n}\n\nbai-catalog-header button#catalog-button.btn-div:focus,\nbai-catalog-header a#catalog-button.btn-div:focus {\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\n\nbai-catalog-header button#catalog-button.btn-div:active,\nbai-catalog-header a#catalog-button.btn-div:active {\n  background-image: none;\n  outline: 0;\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  background-color: #d4d4d4;\n  border-color: #8c8c8c;\n  color: #333;\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
